import PropTypes from 'prop-types';
import Button from './ui/Button';

export default function Nav({ canPurchase, getLabel, onNextBtnClick, onPrevBtnClick, step }) {
	const getPrevButton = (label) => (
		<Button onClick={onPrevBtnClick} testId="prc-nav-button-prev">
			<span className="arrow">arrow_left_alt</span>
			<span>{label}</span>
		</Button>
	);

	const getNextButton = (label) => (
		<Button onClick={onNextBtnClick} testId="prc-nav-button-next" primary={true}>
			<span>{label}</span>
		</Button>
	);

	const getNavButtons = () => {
		switch (step) {
			case 1:
				return [getPrevButton(getLabel('nav_prev_change_plan')), getNextButton(getLabel('nav_next_review'))];
			case 2:
				return [getPrevButton(getLabel('nav_prev_change_packages')), canPurchase ? getNextButton(getLabel('nav_next_buy')) : null];
			default:
				return [null, null];
		}
	};

	const [prevButton, nextButton] = getNavButtons();

	return prevButton || nextButton ? (
		<nav className="prc-nav">
			<div className="prc-nav__btn prc-nav__btn--prev">{prevButton}</div>
			<div className="prc-nav__btn prc-nav__btn--next">{nextButton}</div>
		</nav>
	) : null;
}

Nav.propTypes = {
	canPurchase: PropTypes.bool.isRequired,
	getLabel: PropTypes.func.isRequired,
	onNextBtnClick: PropTypes.func.isRequired,
	onPrevBtnClick: PropTypes.func.isRequired,
	step: PropTypes.number.isRequired,
};
